export default __webpack_public_path__ + "static/media/chevron-primary.5d69169e.svg";